<template>
  <div>
    <div v-if="isReady" class="funnels__content"
      :class="{ 'visual-only': !hasFunnelFeature }">
      <template v-if="hasFunnelFeature">
        <div v-if="items && items.length" class="scroll_content">
          <div class="funnel__regist--wrap">
            <h2 class="title">{{ $t('funnel.title') }}</h2>
            <span class="txt_url">{{ applyData.real_domain || applyData.domain }}</span>
            <ui-button
              v-if="!isShared && userData.updatePermission"
              primary
              iconName="icon--plus-white"
              @click="$router.push({ name: 'funnel.add', params: { aid } })"
              class="btn__register">
              {{ $t('common.register') }}
            </ui-button>
          </div>

          <div class="wrap_table wrap_table2">
            <table>
              <colgroup>
                <col style="width:*">
                <col style="width:80px" v-if="userData.updatePermission">
                <col style="width:121px">
                <col style="width:120px">
                <col style="width:107px">
                <col style="width:50px" v-if="userData.updatePermission">
              </colgroup>
              <thead>
              <tr>
                <th>
                  <sort-options
                    columnName="name"
                    :sortColumn="sortColumn"
                    :isSortAsc="isSortAsc"
                    @onSortOptionChange="onSortOptionChange">
                    <span v-html="$t('common.table.header.funnelName')"></span>
                  </sort-options>
                </th>
                <th v-if="userData.updatePermission">
                  <span v-html="$t('common.table.header.setting')"></span>
                </th>
                <th>
                  <sort-options
                    columnName="state"
                    :sortColumn="sortColumn"
                    :isSortAsc="isSortAsc"
                    @onSortOptionChange="onSortOptionChange">
                    <span v-html="$t('common.table.header.status')"></span>
                  </sort-options>
                </th>
                <th>
                  <sort-options
                    columnName="regDate"
                    :sortColumn="sortColumn"
                    :isSortAsc="isSortAsc"
                    @onSortOptionChange="onSortOptionChange">
                    <span v-html="$t('common.table.header.createdAt')"></span>
                  </sort-options>
                </th>
                <th>
                  <span v-html="$t('common.table.header.report')"></span>
                </th>
                <th v-if="userData.updatePermission">
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td class="txt-left data__funnel-name" :class="{ disabled: item.state === 'ing' }" @click="onGoToFunnelView(item)">
                  <div class="inner_cell ellipsis">
                    <!-- todo: i18n (Steps) -->
                    <span class="txt_num">{{ item.funnelList.length }} Steps</span>
                    <span class="funnel-name ellipsis">{{ item.name }}</span>
                  </div>
                </td>
                <td class="data__setting" v-if="userData.updatePermission">
                  <i class="icon icon--dashboard-setting"
                     :class="{disabled: isShared}"
                     @click="onGotoEdit(item)"></i>
                </td>
                <td>
                  <div :class="`state state-${item.state}`">{{ $t(`funnel.state.${item.state}`) }}</div>
                </td>
                <td class="date">{{ item.regDate | dateFormatTimezone(userData.timezoneName) }}</td>
                <td>
                  <ui-button size="small"
                             iconName="icon--dashboard-confirm"
                             :disabled="item.state === 'ing'"
                             @click="onGoToFunnelView(item)"
                             class="button_report">
                    {{ $t('common.view') }}
                  </ui-button>
                </td>
                <td class="data__delete" v-if="userData.updatePermission">
                  <button
                    v-if="!isShared"
                    class="icon icon--delete"
                    @click="onDeleteClick(item)"></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <back-to-top/>
        </div>

        <div v-else-if="userData.updatePermission" class="content__no-list">
          <div class="bg--funnel-no-list">
            <div class="text--wrap">
              <div>
                <p class="title" v-html="$t('funnel.noList.title')"></p>
                <p class="desc" v-html="$t('funnel.noList.desc')"></p>
              </div>
              <h2>
                <i class="icon icon--funnel-size40"></i><br>
                <i class="icon icon--logo-red"></i><br>
                <strong>{{ $t('funnel.title') | upper }}</strong>
              </h2>
            </div>
            <div class="bg--funnel-light-green">
              <p class="text-100" v-html="$t('funnel.noList.bgText.text100')"></p>
              <p class="text-50">50%</p>
            </div>
            <div class="bg--funnel-dark-green">
              <i class="icon icon--dropoff-size36"></i>
              <p v-html="$t('funnel.noList.bgText.testGoal')"></p>
            </div>
            <ui-button
              primary
              size="large"
              iconName="icon--plus-white"
              :disabled="isShared"
              @click="onGotoRegister">
              {{ $t('common.register') }}
            </ui-button>
          </div>
        </div>
        <div v-else class="content__no-list">
          <content-box class="funnel-no-list" :width="'770px'" :height="'508px'">
            <div class="header--funnel-no-list">
              <i class="icon icon--logo-red"></i>
              <h2 v-html="$t('funnel.noList.notAvailable')"></h2>
            </div>
            <div class="bg--funnel-no-list">
              <div class="text--wrap">
                <div>
                  <p class="title" v-html="$t('funnel.noList.title')"></p>
                  <p class="desc" v-html="$t('funnel.noList.desc')"></p>
                </div>
              </div>
              <div class="bg--funnel-light-green">
                <p class="text-100" v-html="$t('funnel.noList.bgText.text100')"></p>
                <p class="text-50">50%</p>
              </div>
              <div class="bg--funnel-dark-green">
                <i class="icon icon--dropoff-size36"></i>
                <p v-html="$t('funnel.noList.bgText.testGoal')"></p>
              </div>
            </div>
          </content-box>
        </div>
      </template>
      <div v-else class="content__no-feature">
        <p class="logo"><i class="icon icon--logo-red"></i></p>
        <p class="title">
          {{ $t('funnel.noFeature.title')}}
        </p>
        <p class="desc" v-html="$t('funnel.noFeature.desc')"></p>
        <p class="action">
          <ui-button primary class="btn-upgrade"
                     :to="{ name: 'managePlan' }">
            {{ $t('common.upgradePlan') }}
          </ui-button>
        </p>
        <div class="guide">
          <div class="bg"></div>
          <p class="guide-title" v-html="$t('funnel.noFeature.guideTitle')"></p>
          <p class="guide-desc" v-html="$t('funnel.noFeature.guideDesc')"></p>
        </div>
      </div>
    </div>
    <dimmed v-if="isLoading">
      <ui-loading-circle :descText="'loadingDot'" :applyBackground="true" />
    </dimmed>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getFunnelList, deleteFunnel } from '@/api/funnel'
import { getBasicInfoData } from '@/api/report'
import { getNotice } from '@/api/notice'
import { create } from 'vue-modal-dialogs'
import AppDialog from '@/components/ui/AppDialog'
import BackToTop from '@/components/ui/BackToTop'
import UiButton from '@/components/ui/UiButton'
import SortOptions from '@/components/ui/SortOptions'
import NoticePopup from '@/components/ui/NoticePopup'
import Cookies from 'js-cookie'
import { getI18n } from '@/libs/i18n'
import { dateFormatTimezone, getDefaultDevice, utcToLocalTimezone } from '@/libs/utils'
import { addDays, format } from 'date-fns'
import ContentBox from '@/components/ui/ContentBox'
import Dimmed from '@/components/ui/Dimmed'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'

const openDialog = create(AppDialog, 'dialogType')
const openCustomDialog = create(AppDialog, 'customData')
const openNotice = create(NoticePopup)

export default {
  name: 'FunnelList',
  components: {
    UiLoadingCircle,
    Dimmed,
    ContentBox,
    BackToTop,
    UiButton,
    SortOptions
  },
  data () {
    return {
      isReady: false,
      isLoading: false,
      hasFunnelFeature: false,
      items: [],
      headers: [
        {
          name: this.$t('common.table.header.funnelName'),
          sortColumn: 'name'
        },
        {
          name: this.$t('common.table.header.setting')
        },
        {
          name: this.$t('common.table.header.status'),
          sortColumn: 'state'
        },
        {
          name: this.$t('common.table.header.createdAt'),
          sortColumn: 'regDate'
        },
        {
          name: this.$t('common.table.header.report')
        },
        {
          name: '&nbsp;'
        }
      ],
      sortColumn: 'regDate',
      isSortAsc: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'applyData',
      'planData',
      'reportPeriod'
    ]),
    aid () {
      return this.applyData._id
    },
    isShared () {
      return this.applyData.meta.shared
    }
  },
  created () {
    if (this.planData.feature.funnels || this.isShared) {
      this.hasFunnelFeature = true

      const param = {
        sid: this.applyData.sid,
        aid: this.applyData._id
      }

      getFunnelList(param).then(items => {
        const realDomain = this.applyData.real_domain || this.applyData.domain
        this.items = items.filter(item => {
          return item.domain === realDomain
        })
        this.sortItems()
        this.isReady = true
      }).catch(err => {
        this.isReady = true
        console.error(err)
      })
    } else {
      this.isReady = true
    }
    this.loadNotice()
  },
  mounted () {
    window.addEventListener('message', function (msg) {
      if (msg.data) {
        const call = msg.data.call
        const model = msg.data.model
        if (model && model.content && call && call === 'popupPreview') {
          const content = model.content
          const serviceType = model.serviceType
          const location = model.exposureLocation
          if (content && serviceType && location && serviceType === 'beusable' && location === 'funnel') {
            const popupPreviewContainer = document.querySelector('#app > div:nth-child(2)')
            if (popupPreviewContainer) {
              popupPreviewContainer.innerHTML = ''
              const popupId = document.createElement('div')
              popupId.id = 'be-notice-background'
              popupId.className = 'notice_dialog'
              popupId.innerHTML = content
              popupPreviewContainer.append(popupId)
            }
          }
        }
      }
    })
  },
  methods: {
    computedDate (value) {
      return dateFormatTimezone(value, this.applyData.timezoneName, 'YYYY-MM-DD')
    },
    loadNotice () {
      const noticeParam = {
        exposureLocation: 'funnel',
        lang: getI18n().locale
      }
      getNotice(noticeParam).then((data) => {
        if (data.length > 0) {
          data.forEach((item) => {
            const popupId = item._id
            if (popupId) {
              const cookie = Cookies.get('noticePopup' + item._id)
              if (!cookie) {
                openNotice({ data: item }).then((response) => {
                })
              }
            }
          })
        }
      }).catch(noticeErr => {
      })
    },
    sortItems () {
      this.items.sort((a, b) => {
        const aValue = String(a[this.sortColumn])
        const bValue = String(b[this.sortColumn])
        let result = aValue.localeCompare(bValue)

        if (!this.isSortAsc) {
          result = -result
        }
        return result
      })
    },
    onSortOptionChange (column, isAsc) {
      if (this.sortColumn === column && this.isSortAsc === isAsc) {
        return
      }
      this.sortColumn = column
      this.isSortAsc = isAsc
      this.sortItems()
    },
    onGotoRegister () {
      if (this.isShared) return false
      this.$router.push({ name: 'funnel.add', params: { aid: this.aid } })
    },
    onGotoEdit (item) {
      if (this.isShared) return false
      this.$router.push({ name: 'funnel.edit', params: { aid: this.aid, fid: item._id, timezoneName: this.applyData.timezoneName, query: { timezoneName: this.applyData.timezoneName } } })
    },
    onDeleteClick (item) {
      openCustomDialog({
        type: 'confirm',
        iconClass: 'icon--dialog-trash',
        title: this.$t('dialog.funnelDelete.title'),
        // todo: escape pageName
        description: this.$t('dialog.funnelDelete.desc', { itemName: item.name })
      }).then(result => {
        if (result) {
          const fid = item._id
          deleteFunnel(fid).then(data => {
            const index = this.items.findIndex(item => item._id === fid)
            if (index !== -1) {
              this.$delete(this.items, index)
            } else {
              window.location.reload()
            }
          }).catch(err => {
            if (err.isFailed) {
              openDialog('common.error')
            }
          })
        }
      })
    },
    onGoToFunnelView (item) {
      const faid = item['funnelList'][0]['aid']
      let device = 'desktop'
      if (item.state === 'ing') return false
      const today = new Date()
      const endDate = format(utcToLocalTimezone(today, this.applyData.timezoneName), 'YYYY-MM-DD')
      const startDate = format(addDays(utcToLocalTimezone(today, this.applyData.timezoneName), -6), 'YYYY-MM-DD')
      const getBasicInfoDataParam = {
        aid: faid,
        startDate: startDate,
        endDate: endDate
      }
      getBasicInfoData(getBasicInfoDataParam).then(res => {
        const infoData = res
        if (res.pv !== 0) {
          device = getDefaultDevice(res)
        }

        this.$router.push({ name: 'funnel.view', params: { aid: this.aid, fid: item._id, timezoneName: this.applyData.timezoneName, device: device, infoData: infoData, faid }, query: { timezoneName: this.applyData.timezoneName, device: device, faid } })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.funnels__content {
  height: 100%;
  &.visual-only {
    position: relative;
  }
  .funnel__regist--wrap {
    width: 100%;
    display: flex;
    padding-left: 10px;
    align-items: center;
    box-sizing: border-box;
    .link_backpage {
      width: 36px;
      height: 36px;
      margin-right: 15px;
      background-color: #fff;
      border-radius: 50%;
      border: 1px solid #bbb;
      text-indent: -9999px;
      background-position: center;
    }
    .txt_desc {
      font-size: 22px;
      color: #43b6c9;
      &:after {
        content: "";
        display: inline-block;
        margin: 0 8px;
        width: 5px;
        height: 5px;
        background-color: #c1c1c1;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
    .title {
      display: inline-block;
      font-size: 22px;
      color: #444;
      &:after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 12px;
        margin: 0 15px;
        background-color: #d7d7d7;
      }
    }
    .txt_emph {
      font-size: 22px;
      color: #444;
    }
    .txt_url {
      display: inline-block;
      font-size: 16px;
      color: #444;
    }
    .txt_emph + .txt_url {
      padding-left: 15px;
    }
    .btn__register {
      margin-left: auto;
    }
  }
  .wrap_table {
    position: relative;
    margin-top: 18px;
    padding: 20px 20px 30px 20px;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
  }
  .wrap_table2 {
    table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      table-layout: fixed;

      thead {
        tr {
          background-color: #555;
          .btn_sort {
            position: absolute;
            top: 50%;
            right: -20px;
            transform: translateY(-50%);
            width: 16px;
            height: 16px;
          }
        }
        th {
          position: relative;
          height: 50px;
          color: #fff;
          line-height: 1.23;

          &:first-of-type:before,
          &:last-of-type:before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 50px;
            position: absolute;
            top: 0;
            left: -5px;
            background-color: #555;
            border-radius: 5px;
          }

          &:last-of-type:before {
            left: auto;
            right: -5px;
          }

          .inner_item {
            position: relative;
            line-height: 16px;
            display: inline-block;
          }
          .sort_item {
            overflow: hidden;
            position: absolute;
            top: -23px;
            left: 100%;
            min-width: 140px;
            border-radius: 6px;
            box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
            0 0 0 1px rgba(0, 0, 0, 0.25);
            background-color: #fff;
            z-index: 99;
            .sort_order {
              width: 100%;
              display: inline-block;
              line-height: 32px;
              padding-left: 8px;
              padding-right: 8px;
              text-align: left;
              white-space: nowrap;
              &:before {
                display: inline-block;
                content: "";
                width: 16px;
                height: 16px;
                margin: 9px 5px 0 0;
                background-image: url(../../../../assets/img/icon_sort_asc.svg);
                vertical-align: top;
              }
              &:hover {
                background-color: #ebebeb;
              }
              &.on {
                background-color: #fff;
                color: $brandColor;
                font-weight: 500;
                pointer-events: none;
                &:before {
                  background-image: url(../../../../assets/img/icon_sort_asc_on.svg);
                }
              }
            }
            .sort_order2 {
              &:before {
                background-image: url(../../../../assets/img/icon_sort_desc.svg);
              }
              &.on:before {
                background-image: url(../../../../assets/img/icon_sort_desc_on.svg);
              }
            }
          }
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #ebebeb;

          &:hover {
            @include hoverStyle;

            .data__funnel-name:not(.disabled) .funnel-name {
              color: #1199af !important;
            }
          }

          td {
            height: 80px;
            line-height: 14px;
            text-align: center;

            &.txt-left {
              text-align: left;
            }
            &.first-item {
              padding-left: 10px;
            }

            &.data__funnel-name {
              cursor: pointer;
            }

            &.date {
              font-size: 13px;
              color: #666;
            }

            &.data__setting {
              .icon {
                border-radius: 50%;
                width: 32px;
                height: 32px;
                background-position: center;
                &:hover {
                  background-color: rgba(0, 0, 0, 0.06);
                }
                &.disabled {
                  pointer-events: none;
                  opacity: 0.2;
                }
              }
            }

            &.data__delete {
              .icon {
                border-radius: 50%;
                width: 32px;
                height: 32px;
                background-position: center;
                &:hover {
                  background-color: rgba(0, 0, 0, 0.06);
                }
              }
            }

            .txt_desc {
              display: block;
              padding: 93px 0;
            }
            .icon--session {
              margin: 0 auto;
              display: block;
              margin-bottom: 10px;
            }

            .inner_cell {
              position: relative;
              margin-left: 10px;
              .txt_num {
                display: inline-block;
                width: 65px;
                height: 28px;
                margin-right: 20px;
                padding-left: 5px;
                color: #fff;
                line-height: 28px;
                background: url(../../../../assets/img/funnel/funnel_list_bg.svg)
                no-repeat;
                vertical-align: middle;
                &:after {
                  content: "";
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }
              .funnel-name {
                font-size: 14px;
                color: #2f2f2f;
              }
            }
            .text--wrap {
              padding-left: 34px;
              line-height: 16px;
              .icon--stop {
                margin-right: 5px;
                vertical-align: top;
              }
            }
            .icon_item {
              width: 26px;
              height: 26px;
              background-color: #fff;
              border-radius: 50%;
            }
            .state {
              font-size: 13px;
              font-weight: bold;
            }
            .state-start {
              color: $stateRunColor;
            }
            .state-ing {
              color: $stateAnalyzingColor;
            }
            .state-stop {
              color: $stateStopColor;
            }
            .state-deleted {
              color: $errorColor;
            }
            .button_report {
              border: solid 1px #57ab00;
              background-color: #fff;
              color: #4a8500;
            }
          }
        }
      }
    }
  }
  .content__no-list {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .funnel-no-list {
      width: 770px;
      height: 508px;
      @include positionXYcenter;

      .bg--funnel-no-list {
        position: relative;
        top: auto;
        left: auto;
        transform: none;
        background: none;
        width: 710px;
        height: 300px;
        margin: 0 30px 30px 30px;
        background: #2f2f2f;
        border-radius: 5px;
        padding: 32px;

        .text--wrap {
          display: block;
          text-align: center;
        }

        .bg--funnel-light-green {
          bottom: 52px;
          left: calc(50% - 250px);
          width: 428px;
          height: 137px;
          background-size: 100% 100%;

          .text-100 {
            font-size: 20px;

            & /deep/ span {
              font-size: 11px;
            }
          }

          .text-50 {
            font-size: 20px;
            left: 165px;
          }
        }

        .bg--funnel-dark-green {
          top: auto;
          bottom: -50px;
          left: calc(50% - 138px);
          width: 318px;
          height: 102px;
          background-size: 100% 100%;

          .icon--dropoff-size36 {
            width: 29px;
            background-size: 100% 100%;
            left: 57px;
            bottom: calc(100% - 32px);
          }

          p {
            font-size: 11px;
            bottom: calc(100% + 8px);

            & /deep/ span {
              font-size: 20px;
            }
          }
        }
      }
    }

    .header--funnel-no-list {
      padding: 30px;

      h2 {
        font-weight: bold;
        color: #555555;
        font-size: 28px;
        padding: 50px 0 20px 0;
        text-align: center;
      }
    }

    .bg--funnel-no-list {
      position: relative;
      padding: 115px 35px 0;
      box-sizing: border-box;
      margin: 0 auto 7px auto;
      color: #fff;
      @include positionXYcenter;

      .text--wrap {
        @include flexXbetween;

        .title {
          font-size: 20px;
          font-weight: bold;
          line-height: 1.4;
        }
        .desc {
          margin-top: 9px;
          font-size: 14px;
          line-height: 1.5;
        }
        h2 {
          text-align: right;
          .icon--funnel-size40 {
            position: relative;
            left: 2px;
          }
          .icon--logo-new {
            margin-top: 9px;
          }
          strong {
            margin-top: 3px;
            font-size: 60px;
            font-weight: bold;
            display: inline-block;
          }
        }
      }
      .bg--funnel-light-green {
        position: absolute;
        bottom: 69px;
        left: calc(0px - 58px);
        font-size: 25px;
        font-weight: bold;

        .text-100 {
          position: absolute;
          top: 48px;
          left: 20px;

          /deep/ span {
            display: block;
            font-size: 14px;
            padding-left: 3px;
          }
        }
        .text-50 {
          position: absolute;
          bottom: 8px;
          left: 209px;
        }
       }
      .bg--funnel-dark-green {
        position: absolute;
        top: calc(100% - 69px);
        left: 80px;

        .icon--dropoff-size36 {
          position: absolute;
          bottom: calc(100% - 40px);
          left: 77px;
        }

        p {
          font-size: 14px;
          font-weight: bold;
          position: absolute;
          left: calc(100% + 5px);
          bottom: calc(100% + 5px);
          transform: translateY(50%);
          white-space: nowrap;
          /deep/ span {
            display: block;
            font-size: 25px;
            margin-top: 3px;
          }
        }
      }
      .ui-btn {
        position: absolute;
        right: 35px;
        bottom: 35px;
      }
    }
  }
  .content__no-feature {
    width: 770px;
    @include positionXYcenter;
    margin-top: -20px;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    text-align: center;
    color: #555;

    .logo {
      text-align: left;
      margin-bottom: 33px;
    }
    .title {
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .desc {
      font-size: 20px;
      line-height: 1.5;
      margin-bottom: 24px;
    }
    .guide {
      margin-top: 24px;
      position: relative;
      height: 300px;
      padding-top: 32px;
      box-sizing: border-box;
      border-radius: 5px;
      background-color: #2f2f2f;
      color: #fff;
      .bg {
        position: absolute;
        width: 516px;
        height: 239px;
        left: 96px;
        top: 112px;
        background: url(../../../../assets/img/funnel/bg_funnel_no_feature.svg) no-repeat 0 0;
      }
      .guide-title {
        font-size: 20px;
        font-weight: bold;
        line-height: 1.4;
        margin-bottom: 12px;
      }
      .guide-desc {
        font-size: 13px;
        line-height: 1.46;
      }
    }
  }
}
</style>
